/** Origem funcional usada para adaptar as ações do modal compartilhado. */
export enum OrigemAssociacaoItensNFeEntradaEnum {
  CentralNotas = 1,
  EdicaoNota = 2,
  KanbanVinculo = 3,
  KanbanImportacaoXml = 4,
}
